import { render, staticRenderFns } from "./spread-center-inner.vue?vue&type=template&id=323d9cc4"
import script from "./spread-center-inner.vue?vue&type=script&lang=js"
export * from "./spread-center-inner.vue?vue&type=script&lang=js"
import style0 from "./spread-center-inner.vue?vue&type=style&index=0&id=323d9cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports